var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21.504 10.226-1.785-.21a7.66 7.66 0 0 0-.793-1.872l1.11-1.374a.553.553 0 0 0-.046-.729l-1.84-1.793a.592.592 0 0 0-.747-.045L15.99 5.286a7.974 7.974 0 0 0-1.916-.772l-.214-1.74a.575.575 0 0 0-.56-.483h-2.602a.573.573 0 0 0-.559.484l-.214 1.74a8.039 8.039 0 0 0-1.919.772L6.594 4.206a.59.59 0 0 0-.746.043l-1.84 1.795a.555.555 0 0 0-.043.728l1.109 1.376a7.597 7.597 0 0 0-.793 1.871l-1.784.208a.57.57 0 0 0-.497.546v2.536a.57.57 0 0 0 .497.545l1.785.209c.182.661.448 1.288.792 1.868L3.966 17.31a.555.555 0 0 0 .045.728l1.837 1.794c.194.189.53.21.746.045l1.413-1.084a7.988 7.988 0 0 0 1.919.772l.214 1.74a.573.573 0 0 0 .56.483h2.6a.572.572 0 0 0 .56-.484l.214-1.739a8.058 8.058 0 0 0 1.919-.772l1.413 1.081a.59.59 0 0 0 .746-.043l1.84-1.795a.554.554 0 0 0 .044-.729l-1.11-1.375c.344-.58.61-1.207.793-1.87l1.784-.208a.568.568 0 0 0 .497-.546v-2.535a.567.567 0 0 0-.496-.546zm-9.503 6.686c-2.762 0-5-2.181-5-4.873s2.238-4.874 5-4.874c2.761 0 5 2.182 5 4.874 0 2.692-2.238 4.873-5 4.873z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionsIcon);
export default __webpack_public_path__ + "static/media/actions-icon.a62f3743d8ca29e5a47d42b5e4003a9a.svg";
export { ForwardRef as ReactComponent };